export function replaceGuionToSlashFromString(s: string) {
  if (!s) {
    return "";
  }
  return localToString(s).replace(/-/g, "/");
}

export function localToString(s: any) {
  if (!s) {
    return "";
  }
  return String(s);
}

export const getLastCharFromString = (s: number): string => {
  if (!s) {
    return "";
  }
  const result = s.toString().substring(s.toString().length, 1);
  return result.length === 0 ? s.toString() : result;
};

export function isStringRepeated(array: string[], targetString: string) {
  let stringOccurrences: { [key: string]: boolean } = {};

  for (let i = 0; i < array.length; i++) {
    let currentString = array[i];
    if(currentString !== ""){
        if (stringOccurrences[currentString]) {
            return true;
          } else {
            stringOccurrences[currentString] = true;
          }
    }
    
  }

  // If no repeated strings found, return false
  return false;
}

export const defaultString = {
  requiredText: "Este campo es requerido",
  atLeastOneFile: " Debe seleccionar almenos un archivo para continuar",
  validEmail: "Favor digitar un email válido",
  validUrl: "Favor digitar un URL válido",
  validPhone: "Favor digitar un teléfono válido",
  validCedula: "Cédula no válida, introduzca otra cédula",
  validPassword: "validPassword",
  passwordDoesntMatch: "passwordDoesntMatch",
  passwordNeedBeDifferent: "passwordNeedBeDifferent",
};
